import { isLateSubmission } from '../../utils/isLateSubmission';
import translations from './translations';

export const LOCKED_FILTER_KEY = translations.unAssigned.en;
export const UNASSIGNED_FILTER_KEY = 'Unassigned';

export const getUnassignedFilterKey = isNcleAlefAssignment =>
  isNcleAlefAssignment ? UNASSIGNED_FILTER_KEY : LOCKED_FILTER_KEY;

export const studentListFilters = [
  {
    key: 'All',
    locale: {
      ar: 'الجميع',
    },
  },
  {
    key: 'Pending Submission',
    locale: {
      ar: 'في انتظار التسليم',
    },
  },
  {
    key: 'Pending Evaluation',
    locale: {
      ar: 'التقييم قيد الانتظار',
    },
  },
  {
    key: 'To Be Returned',
    locale: {
      ar: 'لم يتم إرجاعه بعد',
    },
  },
  {
    key: 'Returned',
    locale: {
      ar: 'تم الإرجاع',
    },
  },
  {
    key: 'Late Submissions',
    locale: {
      ar: 'تسليم متأخر',
    },
  },
  {
    key: 'Left the Class',
    locale: {
      ar: 'Left the Class',
    },
  },
  {
    key: LOCKED_FILTER_KEY,
    locale: {
      ar: translations.unAssigned.ar,
    },
  },
];

export const studentListFilterFn = {
  All: item => item,
  'Pending Submission': ({ submission }) =>
    !submission || (submission && !submission.submittedOn),
  Submitted: ({ submission }) =>
    submission && submission.submittedOn && submission.status === 'SUBMITTED',
  Evaluated: ({ submission }) =>
    submission && submission.evaluatedOn && !submission.returnedOn,
  Returned: ({ submission }) => submission && submission.returnedOn,
  'Late Submissions': ({ submission }, dueOn) =>
    submission && isLateSubmission(dueOn, submission.submittedOn),
};

export const getFilterSelectionFromLocalStorage = () => {
  const filter = localStorage.getItem('dashboardFilterSelection');
  return filter ? JSON.parse(filter) : studentListFilters[0];
};
